import { useEffect, useMemo, useState } from "react";
import { api, getApiErrorMessage } from "../services/api";
import { createTranslator, LANGUAGE_OPTIONS } from "../i18n";

export default function RegisterPage({ setToken, language, setLanguage, onRegistered }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [preferredLanguage, setPreferredLanguage] = useState(language);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const t = useMemo(() => createTranslator(language), [language]);

  useEffect(() => {
    setPreferredLanguage(language);
  }, [language]);

  const register = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await api.post("/register", {
        full_name: fullName,
        email,
        password,
        preferred_language: preferredLanguage,
      });

      if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
        setToken(res.data.token);
        return;
      }

      onRegistered?.({
        email,
        message: res.data?.message || "",
      });
    } catch (err) {
      console.error("REGISTER ERROR:", err.response?.data || err);
      setError(getApiErrorMessage(err, t("auth.register.error", "Could not create your account.")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>{t("auth.register.title", "Create account")}</h2>
      <p>{t("auth.register.description", "Create your profile to save location, default radius and smart lists.")}</p>

      <input
        className="auth-input"
        placeholder={t("auth.name", "Name")}
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
      />

      <input
        className="auth-input"
        placeholder={t("auth.email", "Email")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        className="auth-input"
        placeholder={t("auth.password", "Password")}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <div style={{ display: "grid", gap: 8 }}>
        <label style={{ fontSize: 13, fontWeight: 700 }}>
          {t("auth.register.language_label", "App language")}
        </label>
        <select
          className="auth-input"
          value={preferredLanguage}
          onChange={(event) => {
            const nextLanguage = event.target.value;
            setPreferredLanguage(nextLanguage);
            setLanguage?.(nextLanguage);
          }}
        >
          {LANGUAGE_OPTIONS.map((option) => (
            <option key={option.code} value={option.code}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {error && <div className="auth-error">{error}</div>}

      <button className="auth-primary" onClick={register} disabled={loading}>
        {loading ? t("auth.register.loading", "Creating...") : t("auth.register.button", "Create account")}
      </button>
    </div>
  );
}
